import React from "react";

const TrustBadges = () => {
  return (
    <div className="trust-badges-bar">
      <div className="container">
        <span className="badge-item">
          <i className="fas fa-shield-alt" />
          <strong>30-Day Warranty</strong>&nbsp;on All Repairs
        </span>
        <span className="badge-item">
          <i className="fas fa-bolt" />
          <strong>Same-Day Service</strong>&nbsp;Available
        </span>
        <span className="badge-item">
          <i className="fas fa-star" />
          <strong>4.6/5 Rating</strong>&nbsp;(163 Reviews)
        </span>
        <span className="badge-item">
          <i className="fas fa-award" />
          <strong>19+ Years</strong>&nbsp;Experience
        </span>
      </div>
    </div>
  );
};

export default TrustBadges;
